<template>
    <router-view></router-view>
</template>

<script>

import "@/assets/js/app";
import { mapActions } from 'vuex';
export default {
  name: 'App',
  async mounted() {
    // Récupérer le chemin actuel AVANT toute redirection
    const initialPath = window.location.pathname;
    console.log('📍 App: Chemin initial (window.location):', initialPath);

    try {
      // Essayer de charger depuis localStorage d'abord
      try {
        await this.$store.dispatch('auth/loadFromLocalStorage');
        console.log('✅ App: Utilisateur chargé depuis localStorage');
      } catch (e) {
        // Si échec, essayer checkToken
        await this.checkAuth();
        console.log('✅ App: Utilisateur chargé via checkToken');
      }

      // Attendre un peu que le routeur soit prêt
      await this.$nextTick();

      // Décider si on doit rediriger
      // On redirige seulement si on est sur /, /login ou pas connecté
      const shouldRedirectToHome = initialPath === '/' ||
                                  initialPath === '/login' ||
                                  !initialPath;

      if (shouldRedirectToHome) {
        console.log('📍 App: Redirection vers Home (chemin initial vide ou login)');
        this.$router.replace({ name: 'Home' });
      } else {
        console.log('📍 App: Garde la route actuelle:', initialPath);
      }

    } catch (err) {
      console.log('❌ App: Erreur auth, redirection vers Login');
      this.$router.replace({ name: 'Login' });
    }
  },
  methods: {
    ...mapActions({
      checkAuth: 'auth/checkToken'
    })
  }

}
</script>


<style></style>
